import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Lock, User, CheckCircle2, AlertCircle } from 'lucide-react';
import './Login.css';
import { auth } from '../firebase/firebase-config';
import bigmaLogo from '../../assets/bigmalogo.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();

  const showPopup = (message, type) => {
    setNotification({ show: true, message, type });
    // 3 saniye sonra bildirimi kapat
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 3000);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      showPopup("Giriş başarılı! Yönlendiriliyorsunuz...", "success");
      
      // Başarı mesajı görünsün diye 1.5 saniye sonra yönlendiriyoruz
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
    } catch (error) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        showPopup("E-posta veya şifre hatalı !", "error");
      } else {
        showPopup("Bir hata oluştu, tekrar dene!", "error");
      }
    }
  };

  return (
    <div className="login-container">
      {/* Bildirim Popup'ı */}
      {notification.show && (
        <div className={`notification-popup ${notification.type}`}>
          {notification.type === 'success' ? <CheckCircle2 size={20} /> : <AlertCircle size={20} />}
          <span>{notification.message}</span>
        </div>
      )}

      <form className="login-form" onSubmit={handleLogin}>
        <div className="login-logo">
          <img src={bigmaLogo} alt="Logo" />
          <h2>Yönetim Paneli</h2>
        </div>
        <div className="input-group">
          <User size={20} />
          <input 
            type="email" 
            placeholder="E-posta" 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>
        <div className="input-group">
          <Lock size={20} />
          <input 
            type="password" 
            placeholder="Şifre" 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <button type="submit" className="login-btn">Güvenli Giriş</button>
      </form>
    </div>
  );
};

export default Login;